import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import FeedbackList from '@components/feedbackList';
import FeedbackFilter from '@components/feedbackFilter';
import type { FeedbackFilterOption, FeedbackFilterParams } from '@components/feedbackFilter';
import type { FeedbackProductCategory, FeedbackProductItem, FetchProductsParams } from '@components/feedbackProductPicker';
import type { FeedbackProblemCategory, FeedbackProblemItem } from '@components/feedbackProblemPicker';
import { display } from 'html2canvas/dist/types/css/property-descriptors/display';
import DownloadApp from '@components/downloadApp';
import SidebarTopicList from '@components/sidebarTopicList';
import SidebarUserInfo from '@components/sidebarUserInfo';
import classNames from 'classnames';
interface FeedbackListPCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    feedbackList?: any[];
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    filterParams?: FeedbackFilterParams;
    searchInputValue?: string;
    solveStateList?: FeedbackFilterOption[];
    problemList?: FeedbackFilterOption[];
    problemCategories?: FeedbackProblemCategory[];
    productList?: FeedbackFilterOption[];
    productCategories?: FeedbackProductCategory[];
    daysList?: FeedbackFilterOption[];
    onSearchChange?: (value: string) => void;
    onSearchConfirm?: () => void;
    onFilterChange?: (key: keyof FeedbackFilterParams, value: string) => void;
    onProblemSelect?: (problem: FeedbackProblemItem | null) => void;
    onProductSelect?: (product: FeedbackProductItem | null) => void;
    fetchProducts?: (params: FetchProductsParams) => Promise<FeedbackProductItem[]>;
    searchKeyword?: string;
    totalCount?: number;
}

interface FeedbackListPCState {
    loading: boolean;
    error: any
    pageLoaded: any
}

@inject('app', 'site', 'user', 'thread')
@observer
class FeedbackListPCPage extends BasePage<FeedbackListPCPageProps, FeedbackListPCState> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
    };

    componentDidMount() {
        super.componentDidMount();
    }

    renderFeedbackList = () => {
        const { feedbackList, loading, hasMore, onLoadMore, searchKeyword } = this.props;
        return (
            <div style={{ marginBottom: 16 }}>
                <div className={styles.feedbackListBox}>
                    <FeedbackList
                        data={feedbackList}
                        loading={loading}
                        hasMore={hasMore}
                        onLoadMore={onLoadMore}
                        searchKeyword={searchKeyword}
                        namespace="feedbackList"
                        emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                        emptyBoxStyle={{minHeight: '500px',display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center'}}
                    />
                </div>
            </div>
        );
    }

    // 右侧内容
    readerRight = () => {
        return (
            <div className={styles.rightContent}>
                {/* 用户信息 */}
                <SidebarUserInfo isFeedback={true}></SidebarUserInfo>
                {/* 下载app */}
                <DownloadApp></DownloadApp>
                {/* 热门话题 */}
                <SidebarTopicList></SidebarTopicList>
                
            </div>
        );
    }

    render() {
        const {
            filterParams,
            searchInputValue,
            solveStateList,
            problemList,
            problemCategories,
            productList,
            productCategories,
            daysList,
            onSearchChange,
            onSearchConfirm,
            onFilterChange,
            onProblemSelect,
            onProductSelect,
            fetchProducts,
            totalCount,
        } = this.props;

        return (
            <div className={styles.wrapper}>
                <div className={classNames(styles.leftContent, styles.feedbackContent)}>
                    {filterParams && (
                        <FeedbackFilter
                            filterParams={filterParams}
                            searchInputValue={searchInputValue || ''}
                            solveStateList={solveStateList || []}
                            problemList={problemList || []}
                            problemCategories={problemCategories || []}
                            productList={productList || []}
                            productCategories={productCategories || []}
                            daysList={daysList || []}
                            layoutStyles={styles}
                            onSearchChange={onSearchChange}
                            onSearchConfirm={onSearchConfirm}
                            onFilterChange={onFilterChange}
                            onProblemSelect={onProblemSelect}
                            onProductSelect={onProductSelect}
                            fetchProducts={fetchProducts}
                            totalCount={totalCount}
                        />
                    )}
                    {this.renderFeedbackList()}
                </div>
                {this.readerRight()}
            </div>
        );
    }
}

export default withRouter(FeedbackListPCPage);
